import { lazy, Suspense } from 'react';
import { ImageViewerProps } from './interfaces';

const ImageViewerComponent = lazy(() =>
  import('./ImageViewer').then((mod) => ({ default: mod.ImageViewer }))
);

function ImageViewerFallback() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1e1e1e',
        borderRadius: '4px',
        color: '#fff',
      }}
    >
      <div>
        <div className="spinner-border text-light mb-2" role="status">
          <span className="visually-hidden">Loading viewer...</span>
        </div>
        <div style={{ fontSize: '14px', opacity: 0.7 }}>Loading image viewer...</div>
      </div>
    </div>
  );
}

export function ImageViewerLazy(props: ImageViewerProps) {
  return (
    <Suspense fallback={<ImageViewerFallback />}>
      <ImageViewerComponent {...props} />
    </Suspense>
  );
}

export default ImageViewerLazy;
